import {HttpErrorResponse} from '@angular/common/http';

export default function extractError(ex: HttpErrorResponse): string {
  if (ex.error?.detail) {
    if (typeof ex.error.detail === 'string')
      // Direct exception
      return ex.error.detail;
    else if (Array.isArray(ex.error.detail))
      // ValidationError
      return ex.error.detail.map(d => d.msg).join('Also, ');
    else return ex.error.detail;
  } else return ex.message;
}
